<template>
  <div>
    <div class="custom-section-box">
      <div class="ant-advanced-search-form item">
        <a-spin :spinning="loading">
          <div style="display: inline-block;">
            <cdb-passport-list
              ref="passportListComponent"
              v-if="isEditPassport" 
              :passportList="passportList"
              :customerId="customerId"
              :customerBirthday="customerBirthday"
              :PassportTravelDocList="PassportTravelDocList"
              :isShowEdit="isShowEdit"
              :isMainShow="isMainShow"
              @update="handleUpdate"
            />
            <cdb-customer-other-documents-list
              ref="otherDocumentsListComponent"
              v-if="isEditOther" 
              :otherList="otherList"
              :customerId="customerId"
              :customerBirthday="customerBirthday"
              :PassportTravelDocList="PassportTravelDocList"
              :isShowEdit="isShowEdit"
              :isMainShow="isMainShow"
              @update="handleUpdate"
            />
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import CdbCustomerOtherDocumentsList from './CdbCustomerOtherDocumentsList'
import CdbPassportList from './CdbCustomerPassportList'
import CustomerApi from '@/api/api-cdb-custome-v2'
import { TravelDoc } from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerPassportPage',
  components: {
    CdbCustomerOtherDocumentsList,
    CdbPassportList
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    customerBirthday: {
      type: [String],
      default: null
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: true,
      isEditPassport: true,
      isEditOther: true,
      passportList: [],
      otherList: [],
      PassportTravelDocList: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      const resData = await TravelDoc.getDict()
      this.PassportTravelDocList = this.copyDataByJSON(resData)
      try {
        const res = await CustomerApi.getPassport(this.customerId)
        const data = res.data
        // 护照类别
        this.passportList = data.passportList || []
        this.otherList = data.otherPassportList || []
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log('error', e)
      }
    },
    handleCancel () {
      this.isEditPassport = true
    },
    handleUpdate () {
      this.loadData()
      this.$emit('update')
    }
  },
  watch: {
  }
}
</script>
<style lang="less" scoped>
.custom-section-box {
  ::v-deep .ant-advanced-search-form {
    padding-top: 12px;
  }
  .item ::v-deep .ant-col {
    padding-top: 0;
    padding-bottom: 6px;
  }
}
::v-deep .ant-form-item-control {
  line-height: 32px;
}
</style>
